/* eslint-disable react-hooks/exhaustive-deps */
import { useForm, FormProvider } from 'react-hook-form';

import useBrands from 'providers/root/BrandsProvider/useBrands';

import { MenuForm } from 'components/MenuMakeImport/MenuForm';

import { getOperationTimes, getProvidersValues, defaultMenu, menuFormIsDirty, menuFormIsValid } from 'utils/menuMaker';

export const SuccessStep = ({ onSubmit }) => {
  const { brandSelected } = useBrands();
  const methods = useForm({ mode: 'onChange', defaultValues: { timeFields: [{}] } });

  const watchFields = methods.watch();

  const isFormDirty = menuFormIsDirty(false, defaultMenu, watchFields);
  const isFormValid = menuFormIsValid(methods.formState, watchFields?.timeFields);

  const handleSaveMenu = () => {
    const data = watchFields;

    const sendValues = {
      name: data?.nameMenuField,
      operationTimes: getOperationTimes(data.timeFields),
      providers: getProvidersValues(data),
      [brandSelected && 'brand']: brandSelected?.uuid,
    };

    return onSubmit(sendValues);
  };

  return (
    <FormProvider {...methods}>
      <MenuForm disabled={!(isFormDirty && isFormValid)} onSaveMenu={handleSaveMenu} />
    </FormProvider>
  );
};
